import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
// Meta Pixel Code
const PIXEL_ID = 'TU_PIXEL_ID_AQUI'; // Replace with actual ID
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel
    import('react-facebook-pixel').then(x => x.default).then(ReactPixel => {
      ReactPixel.init(PIXEL_ID);
      ReactPixel.pageView();
    });
  }, []);
  return <LandingPage data-id="element-0" />;
}